import { v4 as uuidv4 } from 'uuid';
import { get, writable } from 'svelte/store';
import { EThemes, ThemesDictionary } from './themes';
function createToastStore() {
    const { subscribe, set, update } = writable([]);
    return {
        subscribe,
        add: ({ title, message, type, duration }) => {
            update(state => [
                ...state,
                {
                    title,
                    message,
                    type,
                    duration,
                    id: uuidv4()
                }
            ]);
        },
        remove: () => {
            update(state => state.slice(1));
        },
        reset: () => {
            set([]);
        }
    };
}
export const ToastQueue = createToastStore();
export const DEFAULT_APP_STATE = {
    website: {
        checkout: false,
        baseUrl: import.meta && import.meta.env
            ? import.meta.env.BASE_URL
            : process.env.BASE_URL,
        popOverAutoHeight: false,
        iconsBackground: 'none',
        popoverOpen: false,
        showCollapsedIcon: true,
        popoverFooterAlignment: 'center',
        authFlow: 'default',
        flow: null,
        footerVisibility: true,
        fullscreenModal: {
            component: null,
            isVisible: false,
            options: {}
        },
        internalModal: {
            component: null,
            isVisible: false,
            options: {}
        }
    },
    auth: {
        connected: false,
        access_token: undefined,
        providerData: undefined,
        signInOptions: undefined,
        firstCoins: undefined,
        token: undefined,
        account: undefined
    },
    business: {
        id: undefined,
        oauthId: undefined,
        createdAt: undefined,
        updatedAt: undefined,
        name: undefined,
        slug: undefined,
        country: undefined,
        address: undefined,
        addressAdditional: undefined,
        merchantId: undefined,
        city: undefined,
        state: undefined,
        zip: undefined,
        phone: undefined,
        website: undefined,
        ein: undefined,
        title: undefined,
        description: undefined,
        video: undefined,
        videoMetadata: undefined,
        goal: undefined,
        views: undefined,
        coinExchangeRatio: undefined,
        coinPurchaseBonus: undefined,
        coinGiveFirst: undefined,
        coinGiveFirstAmount: undefined,
        coinGiveFirstPotLimit: undefined,
        coinGiveFirstDistributed: undefined,
        coinAwardDistributed: undefined,
        refundsLimitDays: undefined,
        coinRewardPercentage: undefined,
        lat: undefined,
        lng: undefined,
        branchLinks: undefined,
        status: undefined,
        type: undefined,
        logo: undefined,
        loyaltyEnabled: undefined,
        location: undefined
    },
    customer: {
        birthday: undefined,
        country: undefined,
        hasRedeemedFirstCoin: undefined,
        id: undefined,
        invitationUrl: undefined,
        lastSeen: undefined,
        lastname: undefined,
        mail: undefined,
        name: undefined,
        phone: undefined,
        phoneCountryCode: undefined,
        totalRewards: undefined,
        totalSpent: undefined,
        totalVisits: undefined,
        wallet: undefined
    },
    settings: {},
    checkout: {},
    freeCoinsCampaign: {},
    referralProgram: {},
    referralLink: {},
    referralReferredState: {},
    theme: ThemesDictionary[EThemes.BLUE],
    featureFlags: [],
    coupons: [],
    customerImportCampaign: {
        id: undefined,
        coinsReward: undefined,
        status: undefined
    },
    socialReward: []
};
export const AppState = writable(Object.assign({}, DEFAULT_APP_STATE));
export const SetIconsBackground = (style) => {
    AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign({}, state.website), { iconsBackground: style }) })));
};
export const SetNotification = (name, overrideActualNotification = false, notificationParams) => {
    const { category, popoverOpen } = get(AppState).website;
    const isClosingANotification = name === '';
    const actualNotification = category;
    if ((actualNotification &&
        !isClosingANotification &&
        !overrideActualNotification) ||
        (popoverOpen && !isClosingANotification))
        return;
    AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign({}, state.website), { category: name, notificationParams }) })));
};
